// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EO4U81qMJKUxjTXYPqIJ{z-index:2;position:absolute;top:0;left:0;width:100%;height:100%;font-family:Roboto,sans-serif}.QAZbqI1_bLbbGfVU2AQi{width:96px;height:40px;position:absolute;bottom:0;right:0}.xkJZnUfnmdEaAyBIEHrq{width:88px;height:20px;display:flex;align-items:center;justify-content:center;position:absolute;bottom:4px;right:4px;border-radius:20px;padding:0 10px;font-size:11px;text-align:center}.Kkymzh2Lb5fHCrQf4YC5{width:70px;overflow:hidden;white-space:nowrap;text-overflow:clip}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ctaLayer": "EO4U81qMJKUxjTXYPqIJ",
	"ctaClickZone": "QAZbqI1_bLbbGfVU2AQi",
	"ctaButton": "xkJZnUfnmdEaAyBIEHrq",
	"ctaLabel": "Kkymzh2Lb5fHCrQf4YC5"
};
export default ___CSS_LOADER_EXPORT___;
